import React from "react";
import {Badge} from 'react-bootstrap'
import Button from "../../../Components/commonButton/commonButton";
import Api from "../../../services/api";
import Alert from "../../../Components/alert/Alert";
import TextField from "../../../Components/textField/textField";
import Select from "../../../Components/select/select";
import Editable from "../../../Components/editable/editable";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import TableEditable from "../../../Components/tableEditable/TableEditable";
import "../general.css";
import "./items.css";

export default class AltItems extends React.Component {
  state = {
    items: [],
    code: "",
    description: "",
    id: 0,
    message: "",
    reload: false,
    show: false,
    focused: false,
    render: false,
    operations: [],
    operationsAllValues: [],
    units: [{value: "pcs", label: "Peças"},{value: "m", label: "Metro Linear"},{value: "m2", label: "Metro Quadrado"}, {value: "g", label: "Gramas"}],
    selectedUnit: "",
    objEdit: { operation: "", alternative: "", pph: "", piece_cicle: "",time_wait_piece_cicle:"",
    machine: 0},
    machines:[],
    codeOp: "",
    alternative: "",
    pph: "",
    piece_cicle: "",
    timeWaitPieceCicle: "",
    
    popUpShow: false,
    length: null,
    width: null,
    notification: false,
    notification_type: 'success',
    notification_message: ''
  };

  componentDidMount() {
    Api.get("/items/").then((resp) => {
      let arr = []
      resp.data.forEach((element) => {
        arr.push({ value: element.id, label: element.code + ' - ' + element.description, unit: element.unit, length: element.lengthOP, width: element.width })
      })
      this.setState({ items: arr })
    });

    let arr = []
    Api.get('/machines').then((response)=>{
      response.data.forEach(element=>{
        arr.push({value:element.id,label:element.description+element.code})
      })
      this.setState({machines:[...arr]})
    }).catch(err=>{

    })

  }

  SelectItem = (event) => {
    const { value, label,unit,length,width } = this.state.items.find((v) => v.value === event);
    console.log(unit);
    let unitObj;
          if(unit == "pcs"){
            unitObj = {value: "pcs", label: "Peças"};
          }
          if(unit == "m"){
            unitObj = {value: "m", label: "Metro Linear"};
          }
          if(unit == "m2"){
            unitObj = {value: "m2", label: "Metro Quadrado"};
          }
          if(unit == "g"){
            unitObj = {value: "g", label: "Gramas"};
          }
          this.setState({length: length,width: width, selectedUnit: unitObj});
    this.setState({
      id: value, code: label.split('-')[0].trim(),
      description: label.split('-')[1].trim(),
    }, () => {
      Api.get(`/items/${this.state.code}`).then((response) => {
        console.log(response);

        let allPropsArrayDB = response.data.operations;
        let aux = [];
        allPropsArrayDB.forEach(e => {
          aux.push({operation: e.code, alternative: e.alternative, pph: e.pph, piece_cicle: e.piece_cicle, time_wait_piece_cicle: e.time_wait_piece_cicle, machine: e.machine});
        })

        this.setState({ operationsAllValues: aux })
        response.data.operations.forEach(element => {
          element["Ação"] = true
        });
        let arrAux = []
        response.data.operations.forEach(e => {
          arrAux.push({
            ["Código"]: e.code, Alternativa: e.alternative,
            PPH: e.pph, ["Nº Peça/Ciclo"]: e.piece_cicle,
            ['Tempo de espera']:e.time_wait_piece_cicle,
            ['Máquina']: e.machine, ["Ação"]: true
          })
        })

        console.log(this.state.operationsAllValues)
        
        this.setState({ operations: [...arrAux] })
      }).catch(err => {
      })
    })
  };
  componentDidUpdate(prevProps) {
    if (this.state.operations !== prevProps.operations) {
      if (this.state.operations.length > 0 && !this.state.render) {
        this.setState({ render: true })
      }
    }
  }

  altItem = (id) => {
    if (id > 0) {
      Api.put(`/items/${id}`, {
          description: this.state.description,
          code: this.state.code,
          operations:this.state.operationsAllValues,
          unit: this.state.selectedUnit.value,
          width: this.state.width,
          lengthOP: this.state.length
        })
          .then((resp) => {

            this.setState({notification: true, notification_message: "Item alterado com sucesso!"});
            setTimeout(()=>{
              return window.location.reload();
            },2000)
          })
          .catch((error) => {
            this.setState({ message: "" + error.message, show: true });
          });
      } else {
        this.setState({
          message: "Necessário preencher todos os campos.",
          show: true,
        })
    }
  };

  setOperations = (event) => {
    let auxarr = []
    let counter = 0
    event.forEach(e => {
      auxarr.push({
        operation: e["Código"], alternative: e.Alternativa,
        pph: e.PPH, piece_cicle: e['Nº Peça/Ciclo'],
        time_wait_piece_cicle: e['Tempo de espera'],
        machine: e['Máquina']
      })
      counter++
      if (counter === event.length) {
        this.setState({ operationsAllValues: [...auxarr], operations: event }, () => {
        })
      }
    })
  }

  setCode = (value)=>{
    this.setState({code: value});
  }

  setOperation = (value, name) => {
    let obj = this.state.objEdit
    obj[name] = value
    this.setState({ objEdit: obj })
  }

  setCodeOp = (value) => {
    this.setState({codeOp: value});
  }

  setAlternative = (value) => {
    this.setState({alternative: value});
  }

  setPph = (value) =>{
    this.setState({pph: value});
  }

  setPieceCicle = (value) => {
    this.setState({piece_cicle: value});
  }

  setTimeWaitPieceCicle = (value) => {
    this.setState({timeWaitPieceCicle: value});
  }

  setlength = (value) => {
    this.setState({length: value});
  }

  setWidth = (value) => {
    this.setState({width: value});
  }

  setPopUpShow = (value) => {
    this.setState({popUpShow: value});
  }

  changeValue = (value) => { this.setState({ description: value }); };
  callbackfunction = () => { this.setState({ show: false }); };
  delItem = (id) => {
    Api.delete(`/items/${id}`).then(() => {
      this.setState({notification: true, notification_message: "Item deletado com sucesso!"});
      setTimeout(()=>{
        return window.location.reload();
      },2000)
    }).catch(err => {
      this.setState({
        message: err.message,
        show: true,
      });
    })
  }

  handleMachines = (value,label) => {
    let obj = this.state.objEdit
    obj['machine'] = label
    const machineOp = this.state.machines.find((e)=> e.value === value)
    this.setState({objEdit:obj,selected_MachineOp:machineOp})
  }

  addOperation = () => {
    this.setState({ count: this.state.count + 1 })
    let obj = {}
    let objPortuguese = {}
    if (this.state.codeOp !== "" && this.state.alternative !== "" && this.state.pph !== "" && this.state.pph !== "." && this.state.piece_cicle !== "" && this.state.piece_cicle !== "."  && this.state.timeWaitPieceCicle !== "" && this.state.timeWaitPieceCicle !== "." && this.state.selected_MachineOp !== "" ) {

      let operations = this.state.operationsAllValues;
      let opAux = operations.filter((element)=> (`${element.operation}${element.alternative}`) == (`${this.state.codeOp}${this.state.alternative}`));
      if(opAux.length > 0 && this.state.operations.length > 0){
        this.setState({ message: "Erro ao adiconar operação! Código e alternativa já adicionados.", show: true })
      }else{
        obj["operation"] = this.state.codeOp;
      objPortuguese["Código"] = this.state.codeOp;
      obj["alternative"] = this.state.alternative;
      objPortuguese["Alternativa"] = this.state.alternative;
      obj["pph"] = this.state.pph.toString().slice(-1) == "." ? parseFloat(this.state.pph.toString().slice(0,-1)) : this.state.pph;
      objPortuguese["PPH"] = this.state.pph.toString().slice(-1) == "." ? parseFloat(this.state.pph.toString().slice(0,-1)) : this.state.pph;
      obj["piece_cicle"] = this.state.piece_cicle.toString().slice(-1) == "." ? parseFloat(this.state.piece_cicle.toString().slice(0,-1)) : this.state.piece_cicle;
      objPortuguese["Nº Peça/Ciclo"] = this.state.piece_cicle.toString().slice(-1) == "." ? parseFloat(this.state.piece_cicle.toString().slice(0,-1)) : this.state.piece_cicle;
      obj["time_wait_piece_cicle"] = this.state.timeWaitPieceCicle.toString().slice(-1) == "." ? parseFloat(this.state.timeWaitPieceCicle.toString().slice(0,-1)) : this.state.timeWaitPieceCicle;
      objPortuguese["Tempo de espera"] = this.state.timeWaitPieceCicle.toString().slice(-1) == "." ? parseFloat(this.state.timeWaitPieceCicle.toString().slice(0,-1)) : this.state.timeWaitPieceCicle;
      obj["machine"] = this.state.selected_MachineOp.label;
      objPortuguese["Máquina"] = this.state.selected_MachineOp.label;
      obj["id"] = this.state.count;

      this.setState({objEdit: obj});
      /*for (let key in this.state.objEdit) {
        if (Object.hasOwnProperty.call(this.state.objEdit, key)) {
          switch (key) {
            case "code":
              obj["Código"] = this.state.objEdit[key]
              break;
            case "alternative":
              obj["Alternativa"] = this.state.objEdit[key]
              break;
            case "pph":
              obj["PPH"] = this.state.objEdit[key]
              break;
            case "piece_cicle":
              obj["Nº Peça/Ciclo"] = this.state.objEdit[key]
              break;
            case "time_wait_piece_cicle":
              obj["Tempo de espera"] = this.state.objEdit[key]
              break;
            case "machine":
              obj["Máquina"] = this.state.objEdit[key]
              break;
          }
        }
      }*/
      objPortuguese["Ação"] = true
      this.setState({ operations: [...this.state.operations, objPortuguese] }, () => {
        this.setState({ operationsAllValues: [...this.state.operationsAllValues, this.state.objEdit] }, () => {
          document.getElementById("alt-item").reset();
          this.setState({
            objEdit: {
              operation: "", alternative: null, pph: 0, piece_cicle: 0,
              time_wait_piece_cicle: 0, machine: 0
            }, selected_MachineOp: ""
          })
        })
      })
      this.setState({codeOp: "", alternative: "", pph: "", piece_cicle: "", timeWaitPieceCicle: "", selected_MachineOp: ""});
      }

      
    } else {
      if(this.state.pph == "." || this.state.piece_cicle == "." || this.state.timeWaitPieceCicle == "."){
        this.setState({ message: "Erro de validação! Os campos numéricos devem ser preenchidos corretamente.", show: true });
      }else{
        this.setState({ message: "Necessário preencher todos os campos do item.", show: true });
      }
    }
  }


  delOperationNew = (code, alternative)=>{
    let operationsAllValues = this.state.operationsAllValues;
    let operations = operationsAllValues.filter((e)=> `${e.operation}${e.alternative}` !== `${code}${alternative}`);
    this.setState({operationsAllValues: operations});
  }

  handleUnit = (value) => {
    const SelectedUnit = this.state.units.find((e) => e.value === value)
    this.setState({ selectedUnit: SelectedUnit})
    if(SelectedUnit !== "" && SelectedUnit !== null){
      this.setPopUpShow(true);
    }
    if(SelectedUnit.value == "pcs" || SelectedUnit.value == "g"){
      this.setlength(null);
      this.setWidth(null);
    }

    if(SelectedUnit.value == "m"){
      this.setWidth(null);
    }
  }

  altOperation = (codeOperation, alternativeOperation, pph, piece_cicle, time_wait_piece_cicle)=>{

    let operation = this.state.operationsAllValues.findIndex((e)=>e.operation == codeOperation && e.alternative == alternativeOperation);
    let operations = this.state.operationsAllValues;
    operations[operation].pph = pph.toString().slice(-1) == "." ? parseFloat(pph.toString().slice(0,-1)) : pph;
    operations[operation].piece_cicle = piece_cicle.toString().slice(-1) == "." ? parseFloat(piece_cicle.toString().slice(0,-1)) : piece_cicle;
    operations[operation].time_wait_piece_cicle = time_wait_piece_cicle.toString().slice(-1) == "." ? parseFloat(time_wait_piece_cicle.toString().slice(0,-1)) : time_wait_piece_cicle;

    this.setState({operationsAllValues: operations});
  }

  render() {
    let { show, message, reload, units, selectedUnit, notification, notification_message, notification_type } = this.state;

    return (
      <div className="item-container box" id="components" style={{flexDirection: "column"}}>
        {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
        {(this.state.popUpShow && this.state.selectedUnit.value != "pcs" && this.state.selectedUnit.value != "g") ? (
        <div className="popUpContainer">
        <div className="popUp">
          <h4 className="popUpTitle">Informações sobre a unidade de medida</h4>
          <div className="inputsPopUp">
            {((this.state.selectedUnit.value == "m") ? (<div className="element">
            <TextField
                section
                focus={false}
                title="Comprimento"
                name="length"
                id={"length"}
                decimal
                value={this.state.length}
                parentCallback={this.setlength}
              />
            </div>) : null)}

            {((this.state.selectedUnit.value == "m2") ? (
              <>
            <div className="element">
            <TextField
                section
                focus={false}
                title="Comprimento"
                name="length"
                id={"length"}
                decimal
                value={this.state.length}
                parentCallback={this.setlength}
              />
            </div>
            <div className="element">
            <TextField
                section
                title="Largura"
                name="width"
                id={"width"}
                decimal
                value={this.state.width}
                parentCallback={this.setWidth}
              />
            </div>
            </>
            ) : null)}
            
          </div>
          
          
            
          <div className="buttonsPopUp">
            <Button title="Salvar" parentCallback={() => {this.setPopUpShow(false)}}/>
            <Button title="Fechar" id="close" parentCallback={() => {this.setPopUpShow(false)}}/>
          </div>
        </div>
      </div>
      ) : null}

        {show ? (
          <Alert
            show={show}
            message={message}
            parentCallback={this.callbackfunction}
            reload={reload}
          />
        ) : null}
        <form className="minibox miniboxItem" id="alt-item">
          <h4>Item:</h4>
          <div className="input_fields_alt_item inputs inputsItem">
            <div className='selectAltItem inputItem element'>
              <Select
                autoSelect={true}
                label="Selecionar Item"
                arrData={this.state.items}
                handleSelect={this.SelectItem}
              />
            </div>
            <div className='tf2AltItem inputItem element'>
              <TextField
                section={false}
                focus={false}
                title="Código"
                min={1}
                max={16}
                value={this.state.code}
                altType={true}
                parentCallback={this.setCode}
              />
            </div>
            <div className='tf1AltItem inputItem element'>
              <TextField
                section={false}
                focus={false}
                title="Descrição"
                min={1}
                max={70}
                value={this.state.description}
                altType={true}
                parentCallback={this.changeValue}
              />
            </div>
            <div className='selectAltItem inputItem element'>
            <div className="element">
              <Select
                autoSelect={true}
                label="Unidade de Medidas"
                arrData={units}
                handleSelect={this.handleUnit}
                selectedID={selectedUnit}
                name={'unit'}
                />
              </div>
              <div className="element badge badgeUnits">
                {
                  (this.state.selectedUnit.value != "pcs" && this.state.selectedUnit.value != "g" && (this.state.length != null || this.state.width != null)) ? (
                    <>
                    <Badge title={"width"} variant="secondary">L:{this.state.width}</Badge>
                    <Badge title={"length"} variant="secondary">C:{this.state.length}</Badge>
                    </>
                  ) : (null)
                }
              </div>
            </div>
          </div>
        </form>
        <div className="minibox miniboxItem">
            <h4>Operações:</h4>
            <div className="inputs inputsItem">
            <div className='tf1AddItem inputItem element'>
              <TextField
                section={false}
                focus={false}
                title="Código"
                name={"code"}
                min={1}
                max={3}
                value={this.state.codeOp}
                validationType="varchar"
                parentCallback={this.setCodeOp}
              />
            </div>
            <div className='tf1AddItem inputItem element'>
              <TextField
                section
                focus={false}
                title="Alternativa"
                name={"alternative"}
                id={"alternative"}
                min={1}
                max={6}
                value={this.state.alternative}
                validationType="int"
                parentCallback={this.setAlternative}
              />
            </div>
            <div className='tf1AddItem inputItem element'>
              <TextField
                section
                focus={false}
                title="PPH"
                name={"pph"}
                id={"pph"}
                decimal
                min={1}
                max={6}
                value={this.state.pph}
                parentCallback={this.setPph}
              />
            </div>
            <div className='tf1AddItem inputItem element'>
              <TextField
                section
                focus={false}
                title="Nº Peça/Ciclo"
                name={["piece_cicle"]}
                id={"piece_cicle"}
                decimal
                min={1}
                max={6}
                value={this.state.piece_cicle}
                parentCallback={this.setPieceCicle}
              />
            </div>
             <div className='tf1AddItem inputItem element'>
              <TextField
                section
                focus={false}
                title="Tempo de espera"
                name={"time_wait_piece_cicle"}
                id={"time_wait_piece_cicle"}
                decimal
                min={1}
                max={6}
                value={this.state.timeWaitPieceCicle}
                parentCallback={this.setTimeWaitPieceCicle}
              /> 
           </div> 
            <div className='tf1AddItem inputItem element'>
              <Select
                label="Máquina"
                selectedID={this.state.selected_MachineOp}
                arrData={this.state.machines}
                handleSelect={this.handleMachines}
                name={'machine'}
              />
            </div>
            
            </div>
        </div>
        <div className="buttons" id="buttonsItems">
        <div className='tf1AddItemBtn submitButton submitButtonItem'>
          <Button title="+ Adicionar"
              parentCallback={() => this.addOperation(this.state.objEdit)} />
              </div>
              <div className='tf1AddItemBtn submitButton submitButtonItem'>
            <Button
              which={false}
              title="Alterar item"
              parentCallback={() => this.altItem(this.state.id)}
            />
            </div>
            <div className='tf1AddItemBtn submitButton submitButtonItem'>
            <Button
              which={false}
              title="Deletar item"
              parentCallback={() => this.delItem(this.state.id)}
            />
            </div>
        </div>
        <div className="minibox miniboxItem">
          
          {this.state.render ?
            <TableEditable data={this.state.operationsAllValues} del={this.delOperationNew} alt={this.altOperation}></TableEditable> : null}
        </div>
        <div className="minibox miniboxItem">
          <div className="form">
          
          </div>
        </div>
        
      </div>
    )
  }
}